import { useState, useEffect } from 'react'
import { BlogService } from '../services/blogService'
import { BlogPost } from '../config/api'

export const useBlog = (slug: string | undefined) => {
  const [blog, setBlog] = useState<BlogPost | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const blogService = BlogService.getInstance()

  useEffect(() => {
    const fetchBlog = async () => {
      if (!slug) {
        setError('Blog post not found')
        setLoading(false)
        return
      }

      try {
        setLoading(true)
        setError(null)
        const blogPost = await blogService.getBlogBySlug(slug)
        setBlog(blogPost)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch blog post')
        setBlog(null)
      } finally {
        setLoading(false)
      }
    }

    fetchBlog()
  }, [slug, blogService])

  const refresh = () => {
    if (slug) {
      setBlog(null)
      setLoading(true)
      setError(null)
      // Re-trigger the effect by setting a new state
      setTimeout(() => {
        blogService
          .getBlogBySlug(slug)
          .then(setBlog)
          .catch((err) =>
            setError(err instanceof Error ? err.message : 'Failed to fetch blog post')
          )
          .finally(() => setLoading(false))
      }, 0)
    }
  }

  return {
    blog,
    loading,
    error,
    refresh,
  }
}
